import React from "react";

import {
  Button,
  DatePicker,
  ButtonToolbar,
  Form,
  Input,
  InputPicker,
  Table,
  Pagination,
  Modal,
  Popover,
  Whisper,
  Divider,
} from "rsuite";
import { invoiceModel } from "../../../formsValidation";
import { useEffect, createContext, useState } from "react";

import { ActionsIcon } from "../../Settings/Components/Locations/Locations";

import styles from "./Emails.module.css";
import { useEmails } from "./useEmails";
import PageContainer from "../../../Components/PageContainer/PageContainer";
import PdfPreview from "./Components/PdfPreview/PdfPreview";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
//import AttachedFiles from "./Components/AttachedFiles/AttachedFiles";
//import ActionLogs from './Components/ActionLogs/ActionLogs';

// import MainForm from "./Components/MainForm/MainForm";
// import ArowBackIcon from "@rsuite/icons/ArowBack";

//import ConfirmationModal from "../../../Components/ConfirmationModal/ConfirmationModal";
// import { useConfirmationModal } from "../../../Components/ConfirmationModal/useConfirmationModal";
import DocumentTitle from "../../../Components/DocumentTitle";
import { default as EmailsHeader } from "./Components/EmailsHeader/EmailsHeader";
import { useEmailsHeader } from "./Components/EmailsHeader/useEmailsHeader";
// import ActionLogs from "./../../../Components/ActionLogs/ActionLogs";
import moment from "moment";

import {
  getAccessLevel,
  getResponsibleName,
  isAttachedInvoicesBlockAvaliable,
} from "../../../helperFunctions";

const { Column, HeaderCell, Cell } = Table;

export const InvoicesContext = createContext(null);
function Emails() {
  DocumentTitle("RitePMS Office - Emails");

  let {
    tableLoading,
    emails,
    setActivePage,
    activePage,
    itemsPerPage,
    emailsArrayLength,
    section,
    form,
    showEditInvoice,
    getEmails,

    ispdfShow,
    selectedPdf,
    numPages,
    pageNumber,
    handlepdfShow,
    sortColumn,
    handleSort,
  } = useEmails();

  let { filter } = useEmailsHeader();

  const accessLevel = getAccessLevel();
  const [logsModal, setLogsModal] = useState(
    /** @type {{ open: boolean, logs: any[], status: string }} */ ({
      open: false,
      logs: [],
      status: "",
    }),
  );
  const [expandedFileErrors, setExpandedFileErrors] = useState(
    /** @type {Record<string, boolean>} */ ({}),
  );
  const [expandedActionsRows, setExpandedActionsRows] = useState(
    /** @type {Record<string, boolean>} */ ({}),
  );

  //const { showConfirmationModal } = useConfirmationModal();

  useEffect(() => {
    getEmails();
  }, [activePage]); //, form

  /** @param {any} rowData */
  const getRowId = (rowData) => rowData?._id || rowData?.createdAt || "";

  /** @param {any} rowData @param {number} fileIndex */
  const getFileErrorId = (rowData, fileIndex) =>
    `${getRowId(rowData)}-file-${fileIndex}`;

  /** @param {any} rowData @param {"logs" | "actions"} section */
  const toggleExpandedSection = (rowData, section) => {
    if (section === "logs") {
      const logs = normalizeExpandedItems(rowData?.logs);
      setLogsModal({ open: true, logs, status: rowData?.status || "" });
      return;
    }

    const rowId = getRowId(rowData);
    if (!rowId) return;

    setExpandedActionsRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  /** @param {any} rowData @param {number} fileIndex */
  const toggleFileError = (rowData, fileIndex) => {
    const fileErrorId = getFileErrorId(rowData, fileIndex);

    setExpandedFileErrors((prev) => ({
      ...prev,
      [fileErrorId]: !prev[fileErrorId],
    }));
  };

  /** @param {any} item */
  const formatExpandedItem = (item) => {
    if (typeof item === "string") {
      return item;
    }

    if (item == null) {
      return "---";
    }

    return JSON.stringify(item);
  };

  /** @param {any} value */
  const normalizeExpandedItems = (value) => {
    if (Array.isArray(value)) {
      return value;
    }

    if (value == null || value === "") {
      return [];
    }

    return [value];
  };

  /** @param {any[]} items @param {number} charsPerLine */
  const getExpandedContentLineCount = (items, charsPerLine) => {
    return items.reduce((total, item) => {
      const text = formatExpandedItem(item);
      return total + Math.max(1, Math.ceil(text.length / charsPerLine));
    }, 0);
  };

  /** @param {any} rowData */
  const getRowHeight = (rowData) => {
    const files = Array.isArray(rowData?.files) ? rowData.files : [];
    const actions = normalizeExpandedItems(rowData?.actions);
    const fileCount = files.length;
    const rowId = getRowId(rowData);
    const isActionsExpanded = !!expandedActionsRows[rowId];
    let expandedFileErrorCount = 0;

    for (let index = 0; index < files.length; index += 1) {
      const fileErrorId = getFileErrorId(rowData, index);

      if (!expandedFileErrors[fileErrorId]) {
        continue;
      }

      const errorText = formatExpandedItem(files[index]?.error);
      expandedFileErrorCount += Math.max(1, Math.ceil(errorText.length / 55));
    }

    const visibleLineCount =
      Math.max(fileCount, 1) +
      expandedFileErrorCount +
      1 +
      (isActionsExpanded
        ? Math.max(getExpandedContentLineCount(actions, 55), 1)
        : 0);

    return Math.max(100, 28 + visibleLineCount * 24);
  };

  let ActionsCell = ({ rowData, dataKey, ...props }) => {
    return (
      <>
        <Cell {...props}>
          <div className={styles.actions_cell_container}>
            {rowData["status"] != "deleted" && (
              <ActionsIcon
                type="edit"
                onEdit={() => {
                  //showEditInvoice(rowData["_id"]);
                }}
              />
            )}
          </div>
        </Cell>
      </>
    );
  };

  let EmailIDCell = ({ rowData, dataKey, ...props }) => {
    const emailDate = moment
      .utc(rowData["createdAt"], moment.ISO_8601)
      .format("DD/MM/YYYY");
    const tooltip = <Popover>ID: {rowData["_id"]}</Popover>;
    return (
      <Cell style={{ height: "30px", padding: "15px 5px 15px 0px" }} {...props}>
        <Whisper
          placement="top"
          controlId="control-id-hover"
          trigger="hover"
          speaker={tooltip}
        >
          <div style={{ fontSize: "13px", paddingLeft: 12 }}>{emailDate}</div>
        </Whisper>
      </Cell>
    );
  };

  let FromCell = ({ rowData, dataKey, ...props }) => {
    const tooltip = (
      <Popover style={{ width: "565px" }}>
        Email body: {rowData["body"]}
      </Popover>
    ); //

    return (
      <Cell
        style={{ height: "165px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div style={{ fontSize: "13px" }} key={rowData["from"]}>
          from: {rowData["from"]}
        </div>
        <div style={{ fontSize: "13px" }} key={rowData["to"]}>
          to: {rowData["to"]}
        </div>
        <Whisper
          placement="top"
          controlId="control-id-hover"
          trigger="hover"
          speaker={tooltip}
        >
          <div style={{ fontSize: "13px" }} key={rowData["subject"]}>
            subject: {rowData["subject"]}
          </div>
        </Whisper>
      </Cell>
    );
  };

  let FilesCell = ({ rowData, dataKey, ...props }) => {
    const rowId = getRowId(rowData);
    const isActionsExpanded = !!expandedActionsRows[rowId];
    const files = Array.isArray(rowData["files"]) ? rowData["files"] : [];
    const actions = normalizeExpandedItems(rowData["actions"]);

    /** @param {any} e @param {string} pdfUrl */
    const handleDownloadPdf = (e, pdfUrl) => {
      e.stopPropagation();

      if (pdfUrl) {
        // window.open(pdfUrl, '_blank');
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };
    const s3url = "https://riteinvoices.s3.eu-west-2.amazonaws.com/";
    return (
      <Cell style={{ padding: "15px 5px 13px 0px" }} {...props}>
        {files.length > 0 &&
          files.map((file, index) => {
            const fileErrorId = getFileErrorId(rowData, index);
            const isFileErrorExpanded = !!expandedFileErrors[fileErrorId];

            return (
              <div key={fileErrorId}>
                <div className={styles.file_row}>
                  {index + 1}. {file?.invoiceNum} | type:{file?.type} | by:{" "}
                  {file?.by} |{" "}
                  {file.status === "invoiceCreated" ? (
                    "Created"
                  ) : (
                    <button
                      type="button"
                      className={styles.inline_toggle_error}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFileError(rowData, index);
                      }}
                    >
                      Error
                    </button>
                  )}
                  |
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlepdfShow(s3url + file?.s3key);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "blue",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    View
                  </button>
                  <span className={styles.actions_download_icon}>
                    <FileDownloadIcon
                      onClick={(e) => handleDownloadPdf(e, s3url + file?.s3key)}
                      style={{
                        fontSize: "11px",
                        marginRight: 10,
                        cursor: "pointer",
                        marginTop: "0px",
                      }}
                    />
                  </span>
                </div>

                {isFileErrorExpanded && (
                  <div className={styles.file_error_list}>
                    <div className={styles.expanded_list_item}>
                      {formatExpandedItem(file?.error)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}

        <div className={styles.expandable_section}>
          <button
            type="button"
            className={styles.inline_toggle}
            onClick={(e) => {
              e.stopPropagation();
              toggleExpandedSection(rowData, "actions");
            }}
          >
            Actions ({actions.length})
          </button>
        </div>

        {isActionsExpanded && (
          <div className={styles.expanded_list}>
            {actions.length > 0 ? (
              actions.map((action, index) => (
                <div
                  className={styles.expanded_list_item}
                  key={`${rowId}-action-${index}`}
                >
                  {index + 1}. {formatExpandedItem(action)}
                </div>
              ))
            ) : (
              <div className={styles.expanded_list_item}>No actions</div>
            )}
          </div>
        )}
      </Cell>
    );
  };

  let EmailStatus = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell style={{ padding: "15px 5px 15px 0px" }} {...props}>
        <button
          type="button"
          className={styles.status_toggle}
          onClick={(e) => {
            e.stopPropagation();
            toggleExpandedSection(rowData, "logs");
          }}
        >
          {rowData["status"]}
        </button>
      </Cell>
    );
  };

  let getRawStyle = (rowData) => {
    let style = "";

    //if (!rowData?.status == '') style = "dueIn7Days";
    if (rowData?.status == "createInvoiceError") {
      console.log("Overdue");
      style = "overDue";
    }

    return style;
  };

  let allEmails_section = (
    <>
      <EmailsHeader />
      <div className={styles.table_container}>
        <Table
          sortColumn={sortColumn}
          onSortColumn={handleSort}
          wordWrap="break-word"
          height={800}
          rowHeight={getRowHeight}
          data={emails}
          loading={tableLoading}
          autoHeight={true}
          rowClassName={getRawStyle}
        >
          <Column sortable width={125} resizable>
            <HeaderCell style={{ height: "30px" }}>
              <span>ID</span>
            </HeaderCell>

            <EmailIDCell dataKey="createdAt" />
          </Column>

          <Column width={475} resizable>
            <HeaderCell> Recipients </HeaderCell>
            <FromCell dataKey="from" />
          </Column>

          <Column width={450} resizable>
            <HeaderCell>Files </HeaderCell>
            <FilesCell dataKey="files" />
          </Column>

          <Column sortable width={180} resizable>
            <HeaderCell>Status</HeaderCell>
            <EmailStatus dataKey="status" />
          </Column>
        </Table>

        <div className={styles.pagination_container}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            size="xs"
            layout={["total", "-", "pager"]}
            total={emailsArrayLength}
            limit={itemsPerPage}
            maxButtons={10}
            activePage={activePage}
            onChangePage={setActivePage}
          />
        </div>
      </div>

      {selectedPdf && (
        <PdfPreview ispdfShow={ispdfShow} selectedPdf={selectedPdf} />
      )}

      <Modal
        open={logsModal.open}
        onClose={() => setLogsModal({ open: false, logs: [], status: "" })}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>Logs — {logsModal.status}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre className={styles.full_width_logs_pre}>
            {logsModal.logs.length > 0
              ? logsModal.logs
                  .map((log, i) => `${i + 1}. ${formatExpandedItem(log)}`)
                  .join("\n\n")
              : "No logs"}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setLogsModal({ open: false, logs: [], status: "" })}
            appearance="subtle"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

  const itemReadonly = false; //isItemReadonly(accessLevel, form.status);

  const showAttachedInvoicesBlock = isAttachedInvoicesBlockAvaliable(
    accessLevel,
    form.status,
  );

  let inputsStatus = "readonly";
  if (
    [
      "New",
      "OCR",
      "OCR Complete",
      "Assigned",
      "Rejected",
      "Not Invoice",
    ].includes(form.invoice_status)
  ) {
    inputsStatus = "can_edit";
  }

  // let form_section = (
  //   <>
  //     <div className={styles.invoices_header}>
  //       <div className={styles.invoices_header_title}>
  //         <div
  //           className={styles.arrow_back_btn}
  //           onClick={() => {
  //             ConfirmationModalNew(
  //               cancel,
  //               countFormChanges,
  //               showConfirmationModal,
  //               resetFormChanges
  //             );
  //           }}
  //         >
  //           <ArowBackIcon className={styles.arrow_back} />
  //         </div>{" "}
  //         {formMode == "create" ? (
  //           "Add Invoice  "
  //         ) : (
  //           <>
  //             {" "}
  //             Edit Invoice | [No. {form?.invoice_id}] {form.invoice_number}{" "}
  //             {<span>({form.invoice_status})</span>}
  //           </>
  //         )}
  //       </div>
  //     </div>

  //     <div className={styles.invoice_file_container}>
  //       <AttachedFiles readonly={inputsStatus == "readonly" ? true : false} />
  //     </div>

  //     <div className={styles.form_container}>
  //       <MainForm
  //         formMode={formMode}
  //         readonly={inputsStatus == "readonly" ? true : false}
  //         invoiceModel={invoiceModel}
  //         formHandler={formHandler}
  //         form={form}
  //         topButton={
  //           <>
  //             <FormButtons
  //               readonly={inputsStatus == "readonly" ? true : false}
  //               formMode={formMode}
  //               status={form?.invoice_status}
  //               countFormChanges={countFormChanges}
  //               cancel={() => {
  //                 ConfirmationModalNew(
  //                   cancel,
  //                   countFormChanges,
  //                   showConfirmationModal,
  //                   resetFormChanges
  //                 );
  //               }}
  //             />
  //           </>
  //         }
  //       />

  //       {
  //         <div style={{ marginTop: "20px", gap: "30px" }}>
  //           <FormButtons
  //             readonly={inputsStatus == "readonly" ? true : false}
  //             formMode={formMode}
  //             status={form?.invoice_status}
  //             countFormChanges={countFormChanges}
  //             cancel={() => {
  //               ConfirmationModalNew(
  //                 cancel,
  //                 countFormChanges,
  //                 showConfirmationModal,
  //                 resetFormChanges
  //               );
  //             }}
  //           />
  //         </div>
  //       }

  //       {form?.actions?.length && <ActionLogs actions={form.actions} />}
  //     </div>

  //     {/* {formMode == 'edit' && (
  //     <DeleteItemBlock item='purchaseOrder' onDelete={deletePurchaseOrder} />
  //   )} */}
  //   </>
  // );

  return (
    <>
      <PageContainer>
        {section == "all Emails" && allEmails_section}
        {/* {section == "form" && form_section} */}
      </PageContainer>

      {/* <ConfirmationModal /> */}
    </>
  );
}

export default Emails;

const Textarea = React.forwardRef((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
));

const ConfirmationModalNew = (
  onClose,
  countFormChanges,
  showConfirmationModal,
  resetFormChanges,
) => {
  if (countFormChanges > 2) {
    showConfirmationModal("cancelexit", onClose);
  } else {
    resetFormChanges();
    onClose();
  }
};

// const FormButtons = ({
//   readonly,
//   formMode,
//   status,
//   countFormChanges,
//   cancel,
// }) => {
//   let { createInvoice, updateInvoice, updateStatus } = useInvoices();
//   const accessLevel = getAccessLevel();
//   const responsibleName = getResponsibleName();
//   const isReadyToBePaidEnabled = ["Admin"].includes(responsibleName)
//     ? true
//     : false;
//   const isPaidEnabled = ["Admin", "Accountant"].includes(responsibleName)
//     ? true
//     : false;
//   const isApprovedisabled = countFormChanges > 1 ? true : false;

//   const createAndUpdateButton = (
//     <Button
//       onClick={formMode == "create" ? createInvoice : updateInvoice}
//       appearance="primary"
//       style={{ width: "150px", marginRight: "20px" }}
//     >
//       Save
//     </Button>
//   );

//   const toolOcrComplete = (
//     <Popover>
//       Set status to "OCR Complete" so the invoice can be reviewed and approved
//     </Popover>
//   );
//   const setOCRComplete = (
//     <Whisper
//       delay={500}
//       placement="topStart"
//       controlId="control-id-hover"
//       trigger="hover"
//       speaker={toolOcrComplete}
//     >
//       <Button
//         onClick={() => {
//           updateStatus("OCR Complete");
//         }}
//         appearance="primary"
//         color="violet"
//         style={{ width: "150px", marginRight: "20px" }}
//       >
//         Set OCR Complete
//       </Button>
//     </Whisper>
//   );

//   const toolApprove = isApprovedisabled ? (
//     <Popover>Save the form before approving</Popover>
//   ) : (
//     <Popover>
//       Approve the invoice and set the status to "Ready for Payment". The invoice
//       will no longer be editable.
//     </Popover>
//   );

//   const approveButton = (
//     <Whisper
//       delay={500}
//       placement="topStart"
//       controlId="control-id-hover"
//       trigger="hover"
//       speaker={toolApprove}
//     >
//       <Button
//         disabled={isApprovedisabled}
//         onClick={() => {
//           updateStatus("Approved");
//         }}
//         appearance="primary"
//         color="green"
//         style={{ width: "150px", marginRight: "20px" }}
//       >
//         Approve
//       </Button>
//     </Whisper>
//   );

//   const tootForPayment = (
//     <Popover>
//       Assign the bank name and update the invoice status to 'Ready to be Paid'
//     </Popover>
//   );
//   const forPaymentButton = (
//     <Whisper
//       delay={500}
//       placement="topStart"
//       controlId="control-id-hover"
//       trigger="hover"
//       speaker={tootForPayment}
//     >
//       <Button
//         disabled={!isReadyToBePaidEnabled}
//         onClick={() => {
//           updateStatus("For payment");
//         }}
//         appearance="primary"
//         color="green"
//         style={{ width: "160px", marginRight: "20px" }}
//       >
//         Set Ready to be Paid
//       </Button>
//     </Whisper>
//   );

//   const toolpaid = <Popover>Set the invoice status to 'Paid'</Popover>;
//   const paidButton = (
//     <Whisper
//       delay={500}
//       placement="topStart"
//       controlId="control-id-hover"
//       trigger="hover"
//       speaker={tootForPayment}
//     >
//       <Button
//         disabled={!isPaidEnabled}
//         onClick={() => {
//           updateStatus("Paid");
//         }}
//         appearance="primary"
//         color="green"
//         style={{ width: "160px", marginRight: "20px" }}
//       >
//         Set as Paid
//       </Button>
//     </Whisper>
//   );

//   const closeButton = (
//     <Button onClick={cancel} appearance="default" style={{ width: "150px" }}>
//       Close
//     </Button>
//   );
//   // if (accessLevel < 1) {
//   //   return <>{closeButton}</>;
//   // }
//   if (accessLevel >= 1 && accessLevel < 3) {
//     return (
//       <>
//         {" "}
//         {createAndUpdateButton} {closeButton}{" "}
//       </>
//     );
//   }

//   if (accessLevel >= 3) {
//     if (status == "OCR")
//       return (
//         <>
//           {createAndUpdateButton} {setOCRComplete} {closeButton}{" "}
//         </>
//       );
//     if (status == "OCR Complete")
//       return (
//         <>
//           {createAndUpdateButton} {approveButton} {closeButton}
//         </>
//       );

//     if (status == "Approved")
//       return (
//         <>
//           {forPaymentButton} {closeButton}
//         </>
//       );
//     if (status == "For payment")
//       return (
//         <>
//           {paidButton} {closeButton}
//         </>
//       );
//   }

//   return <>{closeButton}</>;
// };
